// extracted by mini-css-extract-plugin
export default {"flex_card":"SmallCardComponent_flex_card__iGBUH","icon_image":"SmallCardComponent_icon_image__jO4Nq"};